<router-outlet/>
@if (isSpinnerVisible()) {
  <app-loader></app-loader>
}
